
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aOGTc", function(module, exports) {
/**
 * @generated SignedSource<<c13934bd8e4fb5a840c9dcb46de3981c>>
 * @relayHash bb8cea4badcfeaf6cedd6a9fc61dc70b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99b89f8fb68610aff1aabea5f0e0139006c05c1b6d79cbab227896887bcaf117
const $5ed153dabac7f135$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "archiveNote"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "archiveNote",
                    "variableName": "archiveNote"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "kind": "ScalarField",
            "name": "createOrUpdateArchivePageNote"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "bb8cea4badcfeaf6cedd6a9fc61dc70b",
            "id": "99b89f8fb68610aff1aabea5f0e0139006c05c1b6d79cbab227896887bcaf117",
            "metadata": {},
            "name": "ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation",
            "operationKind": "mutation",
            "text": "mutation ArchivedPageBannerNoteCreateOrUpdateArchivePageNoteMutation($pageId:Long!,$archiveNote:String!){createOrUpdateArchivePageNote(pageId:$pageId,archiveNote:$archiveNote)}"
        }
    };
}();
$5ed153dabac7f135$var$node.hash = "7e1d187203a2e4e6db2cce36a3bc00a0";
var $5ed153dabac7f135$export$2e2bcd8739ae039 = $5ed153dabac7f135$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $cqmCC = parcelRequire("cqmCC");


var $aJv6Q = parcelRequire("aJv6Q");


var $bQm3c = parcelRequire("bQm3c");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $12UWa = parcelRequire("12UWa");


var $ccWUN = parcelRequire("ccWUN");

/* ArchivedPageBannerViewNote.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");





var $l1Ebn = parcelRequire("l1Ebn");

var $ecd190420d808d89$export$4a6bce095eaa04ed = /*#__PURE__*/ function(NoteViewState) {
    NoteViewState["COLLAPSED"] = "COLLAPSED";
    NoteViewState["EXPANDED"] = "EXPANDED";
    NoteViewState["CONTENT_FITS"] = "CONTENT_FITS";
    return NoteViewState;
}({});












const $f7a2182e4fa2be86$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "archive-pages.page-banner.note.actions.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "archive-pages.page-banner.note.actions.show-less",
        defaultMessage: "Show less"
    },
    editNote: {
        id: "archive-pages.page-banner.note.actions.edit-note",
        defaultMessage: "Edit note"
    }
});
const $f7a2182e4fa2be86$export$17379e5368f92c9d = ({ noteViewState: noteViewState, setNoteViewState: setNoteViewState, userCanUpdateNote: userCanUpdateNote, openNoteCreation: openNoteCreation })=>{
    const expandNote = (0, $cozmU.useCallback)(()=>{
        setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).EXPANDED);
    }, [
        setNoteViewState
    ]);
    const collapseNote = (0, $cozmU.useCallback)(()=>{
        setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED);
    }, [
        setNoteViewState
    ]);
    const getExpandCollapseButton = ()=>{
        if (noteViewState !== (0, $ecd190420d808d89$export$4a6bce095eaa04ed).CONTENT_FITS) {
            const [handleClick, buttonText] = noteViewState === (0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED ? [
                expandNote,
                $f7a2182e4fa2be86$export$a7357cdd1f0b0168.showMore
            ] : [
                collapseNote,
                $f7a2182e4fa2be86$export$a7357cdd1f0b0168.showLess
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.ArchivePageActionLink), {
                onClick: handleClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), buttonText));
        }
        return null;
    };
    const getEditNoteButton = ()=>{
        if (userCanUpdateNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.ArchivePageActionLink), {
            onClick: openNoteCreation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f7a2182e4fa2be86$export$a7357cdd1f0b0168.editNote));
        return null;
    };
    const expandCollapseButton = getExpandCollapseButton();
    const editNoteButton = getEditNoteButton();
    if (!expandCollapseButton && !editNoteButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.NoteActionsWrapper), null, expandCollapseButton, expandCollapseButton && editNoteButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.HorizontalSeparator), null), editNoteButton);
};


const $1b09bd3fef175131$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    addNote: {
        id: "archive-pages.page-banner.note.actions.add-note",
        defaultMessage: "Add a note"
    }
});
const $1b09bd3fef175131$var$COMMENT_LINE_HEIGHT = 20;
const $1b09bd3fef175131$var$MAX_COLLAPSED_LINES = 3;
const $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT = $1b09bd3fef175131$var$COMMENT_LINE_HEIGHT * $1b09bd3fef175131$var$MAX_COLLAPSED_LINES; // need both -webkit-line-clamp AND height so that we get the trailing ellipsis AND the slide transition on expand.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b09bd3fef175131$var$NoteWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _23rrnHCILK _3138422ADO _39HuIbz8Lp _3zvHkHwPeg _1U1ZhbbI28 _3iDTPbgJ9S",
            (__cmplp.height || 0) <= $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT ? "_4Gn54R7LI7" : "_4Gn54RZqHV",
            __cmplp.height ? "_0jFU0VQtZt" : "_0jFU0VIZbP",
            __cmplp.className
        ])
    });
});
const $1b09bd3fef175131$export$c6efa7a2c4cc7786 = ({ note: note, userCanUpdateNote: userCanUpdateNote, openNoteCreation: openNoteCreation })=>{
    const [noteViewState, setNoteViewState] = (0, $cozmU.useState)((0, $ecd190420d808d89$export$4a6bce095eaa04ed).CONTENT_FITS);
    const noteRef = (0, $cozmU.useRef)(null);
    const totalNoteHeight = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (noteRef.current) {
            totalNoteHeight.current = noteRef.current.scrollHeight;
            if (totalNoteHeight.current > $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT) setNoteViewState((0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED);
        }
    }, [
        noteRef,
        setNoteViewState
    ]);
    if (note) {
        const currentNoteHeight = noteViewState === (0, $ecd190420d808d89$export$4a6bce095eaa04ed).COLLAPSED ? $1b09bd3fef175131$var$MAX_COLLAPSED_HEIGHT : totalNoteHeight.current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1b09bd3fef175131$var$NoteWrapper, {
            ref: noteRef,
            height: currentNoteHeight,
            "data-testid": "view-archive-note"
        }, note), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7a2182e4fa2be86$export$17379e5368f92c9d), {
            noteViewState: noteViewState,
            setNoteViewState: setNoteViewState,
            userCanUpdateNote: userCanUpdateNote,
            openNoteCreation: openNoteCreation
        }));
    }
    if (userCanUpdateNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.NoteActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        onClick: openNoteCreation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1b09bd3fef175131$export$a7357cdd1f0b0168.addNote)));
    return null;
};









var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lkMYF = parcelRequire("lkMYF");




const $967ea6d7fdc7df40$var$wrapperStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100'
});
const $967ea6d7fdc7df40$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    updateNote: {
        id: "archive-pages.page-banner.note.actions.update-note",
        defaultMessage: "Update"
    },
    saveNote: {
        id: "archive-pages.page-banner.note.actions.save-note",
        defaultMessage: "Add"
    },
    cancelSaveNote: {
        id: "archive-pages.page-banner.note.actions.cancel-note",
        defaultMessage: "Cancel"
    }
});
const $967ea6d7fdc7df40$var$ArchivedPageBannerEditNoteComponent = ({ defaultValue: defaultValue, onSave: onSave, onCancel: onCancel })=>{
    const createNoteRef = (0, $cozmU.useRef)(null);
    const [isSaveDisabled, setIsSaveDisabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        createNoteRef.current?.focus();
        // move cursor to the end of the textarea. its at the start by default.
        const noteLength = createNoteRef.current?.value?.length || 0;
        createNoteRef.current?.setSelectionRange(noteLength, noteLength);
    }, [
        createNoteRef
    ]);
    const handleSave = (0, $cozmU.useCallback)(()=>{
        onSave(createNoteRef.current?.value || '');
    }, [
        onSave,
        createNoteRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $967ea6d7fdc7df40$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkMYF.ArchivedPageNoteInput), {
        noteRef: createNoteRef,
        defaultValue: defaultValue,
        analyticsSource: "archiveList",
        onValidate: (isValid)=>{
            setIsSaveDisabled(!isValid);
        },
        isColorInverted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.NoteActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        isDisabled: isSaveDisabled,
        onClick: handleSave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), defaultValue ? $967ea6d7fdc7df40$export$a7357cdd1f0b0168.updateNote : $967ea6d7fdc7df40$export$a7357cdd1f0b0168.saveNote)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.HorizontalSeparator), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1Ebn.ArchivePageActionLink), {
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $967ea6d7fdc7df40$export$a7357cdd1f0b0168.cancelSaveNote))));
};
const $967ea6d7fdc7df40$export$97bbfc8a7efe60a2 = $967ea6d7fdc7df40$var$ArchivedPageBannerEditNoteComponent;


const $154591b700ba0c88$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    createNoteErrorTitle: {
        id: "archive-pages.page-banner.note.creation.error.title",
        defaultMessage: "We couldn\u2019t add your note"
    },
    updateNoteErrorTitle: {
        id: "archive-pages.page-banner.note.update.error.title",
        defaultMessage: "We couldn\u2019t edit your note"
    },
    createNoteErrorDescription: {
        id: "archive-pages.page-banner.note.creation.error.description",
        defaultMessage: "Try again. If this keeps happening, contact {supportLink} or your space admin."
    },
    createNoteSuccessTitle: {
        id: "archive-pages.page-banner.note.creation.success.title",
        defaultMessage: "Note added"
    },
    updateNoteSuccessTitle: {
        id: "archive-pages.page-banner.note.update.success.title",
        defaultMessage: "Note edited"
    }
});
const $154591b700ba0c88$var$ArchivedPageBannerNoteComponent = ({ note: note, archiverAccountId: archiverAccountId, contentId: contentId, editingNote: editingNote, setEditingNote: setEditingNote, flags: flags })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [createOrUpdateNote, { error: noteCreationError }] = (0, $308Wd.useMutationInterop)((0, $5ed153dabac7f135$export$2e2bcd8739ae039), {
        update: (_cache, { data: responseData })=>{
            const cachedData = (0, $l1uFv.readQueryInterop)({
                query: (0, $ccWUN.default),
                variables: {
                    contentId: contentId
                },
                __callerPackage__: "archive-pages"
            });
            if (cachedData && responseData) {
                const copyOfCachedData = JSON.parse(JSON.stringify(cachedData));
                const contentNode = copyOfCachedData.content?.nodes?.[0];
                if (contentNode) {
                    contentNode.archivedContentMetadata = {
                        ...contentNode.archivedContentMetadata,
                        archiveNote: responseData.createOrUpdateArchivePageNote
                    };
                    (0, $fEmGS.writeQueryInterop)({
                        query: (0, $ccWUN.default),
                        variables: {
                            contentId: contentId
                        },
                        data: copyOfCachedData,
                        __callerPackage__: "archive-pages"
                    });
                }
            }
        },
        onError: ()=>{
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), note ? $154591b700ba0c88$export$a7357cdd1f0b0168.updateNoteErrorTitle : $154591b700ba0c88$export$a7357cdd1f0b0168.createNoteErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$154591b700ba0c88$export$a7357cdd1f0b0168.createNoteErrorDescription,
                    values: {
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cqmCC.AtlassianSupportLink), null)
                    }
                })
            });
        },
        __callerPackage__: "archive-pages"
    });
    const userCanUpdateNote = userId === archiverAccountId;
    const openNoteCreation = (0, $cozmU.useCallback)(()=>{
        setEditingNote(true);
    }, [
        setEditingNote
    ]);
    const closeNoteCreation = (0, $cozmU.useCallback)(()=>{
        setEditingNote(false);
    }, [
        setEditingNote
    ]);
    const handleSaveNote = (0, $cozmU.useCallback)((newArchiveNote)=>{
        (0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'button',
            actionSubjectId: !note ? 'addArchiveNoteSubmitButton' : 'updateArchiveNoteSubmitButton',
            source: 'archivePageBanner',
            attributes: {
                includedNote: !!newArchiveNote
            }
        });
        createOrUpdateNote({
            variables: {
                // Casting as `any` to match original types from ../__types__/CreateOrUpdateArchivePageNoteMutation
                // Ideally pageId should be typed as ID
                pageId: contentId,
                archiveNote: newArchiveNote
            },
            optimisticResponse: {
                createOrUpdateArchivePageNote: newArchiveNote
            }
        });
        closeNoteCreation();
    }, [
        contentId,
        closeNoteCreation,
        createOrUpdateNote,
        createAnalyticsEvent,
        note
    ]);
    const renderNote = ()=>{
        if (editingNote) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $967ea6d7fdc7df40$export$97bbfc8a7efe60a2), {
            defaultValue: note,
            onSave: handleSaveNote,
            onCancel: closeNoteCreation
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b09bd3fef175131$export$c6efa7a2c4cc7786), {
            note: note,
            userCanUpdateNote: userCanUpdateNote,
            openNoteCreation: openNoteCreation
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderNote(), noteCreationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: noteCreationError
    }));
};
const $154591b700ba0c88$export$c47074c5933ae97d = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
})((0, $7aRa9.withFlags)($154591b700ba0c88$var$ArchivedPageBannerNoteComponent));
module.exports["i18n"] = $154591b700ba0c88$export$a7357cdd1f0b0168;
module.exports["ArchivedPageBannerNote"] = $154591b700ba0c88$export$c47074c5933ae97d;

});

parcelRegister("l1Ebn", function(module, exports) {
/* archivePageBannerNoteSharedStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $970b1240ff8943ba$export$247376757894902 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3138422ADO _3iDTPbQ4SZ _0hPCNLQame",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$var$ArchivePageActionLinkAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9aYkv.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3YEZNOdnbC _3iDTPbvbI6 _1kk5Tkmb2E _4keetJBz3j _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
            __cmplp?.isDisabled ? "_0wOv4Q18ZR" : "_0wOv4Q7zJH",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$export$d87e0a494deabb58 = ({ isDisabled: isDisabled = false, onClick: onClick, children: children, ...props })=>{
    const theme = (0, $IQ4Dz.useThemeObserver)(); // During dark-mode tokenization in CCECO-700 we were unable to identify an appropriate
    // design-system token to use to represent this color in such a way that had sufficient
    // contrast with the background colors available in both light and dark modes. As a
    // result we're leaving this as custom for now but adding it as a request to our design
    // team to identify the best path forward for this color.
    const getColor = ()=>{
        if (theme.colorMode === 'dark') return isDisabled ? '#42526E' : '#0052CC';
        else return isDisabled ? '#97A0AF' : '#B3D4FF';
    };
    const onClickInternal = (event)=>{
        if (!isDisabled) onClick?.(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($970b1240ff8943ba$var$ArchivePageActionLinkAnchor, {
        color: getColor(),
        isDisabled: isDisabled,
        "aria-disabled": isDisabled,
        onClick: onClickInternal,
        ...props
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $970b1240ff8943ba$var$Spacer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbEw3P6",
            __cmplp.className
        ])
    });
});
const $970b1240ff8943ba$export$a035dcf9055239cd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($970b1240ff8943ba$var$Spacer, null, "\u2022");
module.exports["NoteActionsWrapper"] = $970b1240ff8943ba$export$247376757894902;
module.exports["ArchivePageActionLink"] = $970b1240ff8943ba$export$d87e0a494deabb58;
module.exports["HorizontalSeparator"] = $970b1240ff8943ba$export$a035dcf9055239cd;

});


//# sourceMappingURL=ArchivedPageBannerContent.e6f3e5ab.js.map
